/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time's up!`)
};

const es_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Se acabó el tiempo!`)
};

const de_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit abgelaufen!`)
};

const nl_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijd is om!`)
};

const fr_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps écoulé !`)
};

const it_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo scaduto!`)
};

const pt_br2_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo esgotado!`)
};

const pt_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo esgotado!`)
};

const ja_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間になりました！`)
};

const zh_timer_times_up = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间到！`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_times_up = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_times_up(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_times_up", locale)
	if (locale === "en") return en_timer_times_up(inputs)
	if (locale === "es") return es_timer_times_up(inputs)
	if (locale === "de") return de_timer_times_up(inputs)
	if (locale === "nl") return nl_timer_times_up(inputs)
	if (locale === "fr") return fr_timer_times_up(inputs)
	if (locale === "it") return it_timer_times_up(inputs)
	if (locale === "pt-BR") return pt_br2_timer_times_up(inputs)
	if (locale === "pt") return pt_timer_times_up(inputs)
	if (locale === "ja") return ja_timer_times_up(inputs)
	return zh_timer_times_up(inputs)
};